/* eslint-disable react/no-danger */
import React from 'react';
import { useHistory } from 'react-router';
import { ROUTE_ACTIVATE_PLAN, ROUTE_ACTIVATE_VOUCHER } from '../../../constants/Routes';
import { getImageUrl } from '../../../config';
import FullPageMessage from '../../common/fullPageMessage/FullPageMessage';

import { SOFTLANDING_BUTTON, SOFTLANDING_TEXT_LINK } from '../../../constants/Copy';
import { generatePath } from 'react-router-dom/cjs/react-router-dom.min';

export default ({
	IMAGE,
	TITLE,
	DESCRIPTION,
	EXISTING_USER_ALLOWED,
	DESCRIPTION_TERMS,
	CLASS_NAME,
	PLAN_SLUG,
}) => {
	const history = useHistory();
	const logo = getImageUrl(IMAGE);

	function handleClick() {
		return history.push(
			PLAN_SLUG
				? generatePath(ROUTE_ACTIVATE_PLAN, {
						plan: PLAN_SLUG,
				  })
				: ROUTE_ACTIVATE_VOUCHER
		);
	}

	const button = {
		onClick: handleClick,
		text: SOFTLANDING_BUTTON,
	};

	const textLink = {
		onClick: handleClick,
		text: SOFTLANDING_TEXT_LINK,
	};

	return (
		<FullPageMessage
			image={logo}
			title={TITLE}
			description={<div dangerouslySetInnerHTML={{ __html: DESCRIPTION }} />}
			descriptionTerms={DESCRIPTION_TERMS}
			button={button}
			textLink={EXISTING_USER_ALLOWED ? textLink : null}
			className={CLASS_NAME}
			isSoftLanding
		/>
	);
};
